var JsonWebTokenError = require('./JsonWebTokenError');

var TokenExpiredError = function (message, expiredAt) {
  JsonWebTokenError.call(this, message);
  this.name = 'TokenExpiredError';
  this.expiredAt = expiredAt;
};

TokenExpiredError.prototype = Object.create(JsonWebTokenError.prototype);

TokenExpiredError.prototype.constructor = TokenExpiredError;

module.exports = TokenExpiredError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/jsonwebtoken/lib/TokenExpiredError.js
 ** module id = 1294
 ** module chunks = 0
 **/